// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2mOVl","visuallyhidden":"_1dRZU","hide-text":"_3UEdN","center":"_2zFMM","noprint":"_3H3Rf","root":"_3Xtny","text":"_2-y68"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-blockquote/styles/feature.scss
 ** module id = 210
 ** module chunks = 2
 **/